let stdLink = 'http://localhost:4500/api'

if (process.env.NODE_ENV === 'production') {
    stdLink = 'https://api.rite.pl/api'
}

export const API = stdLink;
export const MEDIA_BASE = API.replace(/\/api$/, '');
